<template>
  <CommunityCard class="p-4">
    <form>
      <h3 class="text-inherit mb-4">Group Settings</h3>

      <div class="form-group">
        <label for="name">Name</label>
        <input
          type="text"
          v-model="groupName"
          :class="{ 'form-control': true, 'is-invalid': !groupNameValid }"
          name="name"
        />
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea
          name="description"
          class="form-control"
          v-model="groupDesc"
        ></textarea>
      </div>

      <div class="d-flex">
        <div class="form-group mr-4 mb-1">
          <label>Membership</label>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="membershipType"
              id="publicMembership"
              value="public"
              v-model="membershipType"
              checked
            />
            <label class="form-check-label" for="publicMembership">
              Public
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="membershipType"
              id="inviteMembership"
              value="inviteOnly"
              v-model="membershipType"
            />
            <label class="form-check-label" for="inviteMembership">
              Invite only
            </label>
          </div>
        </div>

        <div class="form-group ml-4 mb-1">
          <label>Posts</label>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="postingType"
              id="allowAllPosts"
              value="allowAll"
              v-model="postingType"
              checked
            />
            <label class="form-check-label" for="allowAllPosts">
              Allow all posts
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="postingType"
              id="requireApproval"
              value="requireModeration"
              v-model="postingType"
            />
            <label class="form-check-label" for="requireApproval">
              Require approval
            </label>
          </div>
        </div>
      </div>

      <div class="div d-flex mt-4">
        <button
          class="btn btn-primary mr-2 flex-grow d-lg-block"
          @click.prevent="submit()"
        >
          <div style="display: flex; align-items: center;">
            <i class="material-icons" style="margin-right: 7px;">save</i>
            {{ buttonText }}
          </div>
        </button>
        <button
          class="btn btn-outline btn-danger mr-2 flex-grow d-lg-block"
          @click.prevent="deleteGroup()"
        >
          <div style="display: flex; align-items: center;">
            <i class="material-icons" style="margin-right: 7px;">delete</i>
            {{ deleteButtonText }}
          </div>
        </button>
      </div>
    </form>
  </CommunityCard>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import CommunityCard from "../components/CommunityCard";
import logger from "../utils/logger";

const MEMBER_TYPES = ["public", "inviteOnly"];
const POSTING_TYPES = ["allowAll", "requireModeration"];

export default {
  name: "ForumGroupSettings",
  props: ["groupData"],
  components: {
    CommunityCard,
  },
  data: function() {
    return {
      groupName: "",
      groupDesc: "",
      membershipType: null,
      postingType: null,
      groupNameValid: true,
      isSubmitting: false,
      buttonText: "Save",
      deleteButtonText: "Delete Group",
    };
  },
  mounted() {
    this.groupName = this.groupData.name || "";
    this.groupDesc = this.groupData.description || "";
    this.membershipType =
      MEMBER_TYPES[this.groupData.membership_type] || MEMBER_TYPES[0];
    this.postingType =
      POSTING_TYPES[this.groupData.posting_type] || POSTING_TYPES[0];
  },
  watch: {
    groupData: {
      deep: true,
      handler(newVal) {
        this.groupName = newVal.name || this.groupName;
        this.groupDesc = newVal.description || this.groupDesc;
        this.membershipType =
          MEMBER_TYPES[newVal.membership_type] || MEMBER_TYPES[0];
        this.postingType =
          POSTING_TYPES[newVal.posting_type] || POSTING_TYPES[0];
      },
    },
  },
  methods: {
    submit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      this.groupNameValid = true;
      this.groupName = this.groupName.trim();

      if (!this.validate()) {
        this.isSubmitting = false;
        return;
      }

      this.buttonText = "...";

      forumGroupService
        .updateGroup(
          this.groupData.id,
          this.groupName,
          this.groupDesc,
          this.membershipType,
          this.postingType
        )
        .then((data) => {
          this.$emit("success", "Your group has been updated.");
        })
        .finally(() => {
          this.isSubmitting = false;
          this.buttonText = "Save";
        });
    },
    validate() {
      this.groupNameValid = this.groupName.length > 0;
      return this.groupNameValid;
    },
    deleteGroup() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      this.deleteButtonText = "...";

      const swalWithBootstrapButtons = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Delete " + this.groupName + "?",
          html:
            "Deleting a group will remove it from Community. This action is <b>permanent</b> and may not be undone",
          type: "warning",
          showCancelButton: true,

          confirmButtonText: "Delete",
        })
        .then((result) => {
          if (result.value) {
            forumGroupService
              .deleteGroup(this.groupData.id)
              .then((data) => {
                logger.log("forum.group.deleted", "Forum group deleted", { groupId: this.groupData.id });
                swalWithBootstrapButtons.fire(
                  "Deleted!",
                  "Group deleted.",
                  "success"
                );

                this.$router.push("/me/forum/groups");
              })
              .finally(() => {
                this.deleteButtonText = "Delete Group";
                this.isSubmitting = false;
              });
          } else {
            this.deleteButtonText = "Delete Group";
            this.isSubmitting = false;
          }
        });
    },
  },
};
</script>

<style scoped></style>
